<template>
    <div id="auth" class="container">
        <section id="auth-content" class="box padding w-buttons install">
            <h2>Recuperar Senha</h2>
            <form action="#" class="margin-top-l">
                <div class="item">
                    <div class="flex between">
                        <label>E-Mail</label>
                    </div>
                    <input v-model="email" type="email" placeholder="xxxxx@xxxx.com.br">
                </div>
            </form>

            <div class="buttons flex between middle">
                <router-link to="/" class="button light">Voltar</router-link>
                <a @click="sendRecoveryPassword()" class="button primary">Enviar</a>
            </div>
        </section>
    </div>
</template>

<script>

import { recoveryPassword } from "@/services/auth";


export default {
    name: 'RecoveryPassword',
    data() {
        return {
            email: ""
        }
    },
    methods: {
        sendRecoveryPassword() {
        if (!this.email) {
            return this.$toast.error({
            title: "Erro",
            message: "Você precisa preencher o e-mail"
            });
        }
        recoveryPassword({ email: this.email })
            .then(() => {
                this.$toast.success({
                    title: "Sucesso",
                    message: "Foi enviado um e-mail para a recuperação da senha"
                });
            })
            .catch(error => {
                if (error && error.message === "request-canceled") {
                    return;
                }

                return this.$toast.error({
                    title: "Erro",
                    message: "Ocorreu um erro interno na sua solicitação"
                });
            });
        }
    }
}
</script>
